import { promiseWrapper } from 'utils/promise'

export interface SupportedCurrencies {
  PLN_RATES: string[]
  NOT_PLN_RATES: string[]
}

export interface PeggedPairConfigResponse {
  source_pair: string
  peg_rate: number
}

export interface CurrencyPairs {
  default_currency_pair: string
  main_currency_pairs: string[]
  main_currency_pairs_and_crowns: string[]
  long_rate_pairs: string[]
  supported_currencies: SupportedCurrencies
  pegged_currency_pairs: Record<string, PeggedPairConfigResponse>
}

export interface PeggedPairConfig {
  sourcePair: string
  pegRate: number
}

const fetchCurrencyPairsDataFromAPI = async (): Promise<CurrencyPairs> => {
  return promiseWrapper<CurrencyPairs, never>(`${window.location.origin}/wp-json/support/currency-pairs`, 'GET')
}

// Cached promise for currency pairs data, to avoid multiple API calls.
let currencyPairsPromise: Promise<CurrencyPairs> | null = null
export const getCurrencyPairsData = (): Promise<CurrencyPairs> => {
  if (!currencyPairsPromise) {
    currencyPairsPromise = fetchCurrencyPairsDataFromAPI()
  }
  return currencyPairsPromise
}

export const getPeggedCurrencyPairs = async (): Promise<Record<string, PeggedPairConfig>> => {
  try {
    const { pegged_currency_pairs: data } = await getCurrencyPairsData()

    return Object.fromEntries(
      Object.entries(data).map(([pair, { source_pair, peg_rate }]) => [
        pair,
        { sourcePair: source_pair, pegRate: peg_rate },
      ]),
    )
  } catch {
    return {}
  }
}
